import React from "react";
import { NavLink } from "react-router-dom";
import { useUser } from "src/business-types/grocery/components/UserContext";
import { colorOptions, fontOptions } from "../profile/theme/themeConstants";

interface TabItem {
  path: string;
  label: string;
}

const ReportsMenuTab: React.FC = () => {
  const { user } = useUser();

  // 🔹 Do not render anything if not Restaurant
  if (user?.business_type !== "Restaurant") {
    return null;
  }

  const bgClass = colorOptions[user?.background_colour || "DodgerBlue"];
  const fontClass = fontOptions[user?.font_family || "Sans-serif"];

  const tabs: TabItem[] = [
    { path: "/v1/sales-summary", label: "Sales Summary" },
    { path: "/v1/sales-report", label: "Sales Report" },
  ];

  return (
    <div className="w-full sm:px-6 lg:px-8">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-1.5 w-fit">
        <nav className="flex gap-2" aria-label="Tabs">
          {tabs.map((tab: TabItem) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `px-4 py-2 text-sm sm:text-base font-medium rounded-lg transition-all duration-150 ${fontClass} ${
                  isActive ? `${bgClass} text-white` : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default ReportsMenuTab;
